<template>
    <section id="sports_content">

        <div class="container">

            <div class="row" id="first_row">

                <!-- In Small Screen -->
                <nav aria-label="breadcrumb" class="mt-4 d-block d-lg-none">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'sports' }" class="text-reset">الرياضة والمنافسات
                                التعليمية</router-link>
                        </li>
                    </ol>
                </nav>

                <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                    <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                        <nav aria-label="breadcrumb" class="d-none d-lg-block">
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <router-link :to="{ name: 'sports' }" class="text-reset">الرياضة والمنافسات
                                        التعليمية</router-link>
                                </li>
                            </ol>
                        </nav>

                        <p>شراكات عالمية مع منظمات دولية للبطولات المتخصصة في المنافسات التعليمية والرياضية في مجالات الجيل
                            الصناعي الرابع.</p>

                        <h5 class="mt-3">مسابقات عالمية ، تهدف لإظهار إبداعات الشباب ومهاراتهم</h5>

                        <p>للفئة من 8 إلى 25 عام وذلك عن طريق منافسات في الروبوت والذكاء الاصطناعي وتقام سنويًا بتحديات
                            رياضية وتقنية مع طرح موضوع سنوي للابتكار في المشاكل التي تواجه العالم.</p>

                        <h5 class="mt-3">ما الفائدة التي تعود على الطلاب من هذه المنافسات؟</h5>

                        <ul class="mb-0">
                            <li>تحقيق أهداف رؤية المملكة 2030 في تعزيز مهارات المستقبل لدى الأفراد</li>
                            <li>تمكين ودعم إبداعات الشباب لتطوير العديد من المجالات</li>
                            <li>تطوير المهارات التقنية من خلال برمجة الروبوتات</li>
                        </ul>

                    </div>

                </div>

                <div
                    class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                    <div class="col_two_content">
                        <div class="img_wrapper">
                            <img src="@/assets/images/services/sports_img.webp" alt="">
                        </div>
                    </div>

                </div>

            </div>

            <div class="row mb-3 mb-lg-0" id="second_row">

                <h5 class="mt-3 mb-0">تعرف على البطولات المتاحة</h5>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <a href="https://wrosaudi.com/home">
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/WRO.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">الأولمبياد العالمي للروبوت</h5>
                                </div>
                            </div>
                        </a>

                    </div>

                </div>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <a href="https://tahakoom.gov.sa/v4#/action">
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/plane.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">بطولة الطائرات اللاسلكية</h5>
                                </div>
                            </div>
                        </a>

                    </div>

                </div>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <a href="https://tahakoom.gov.sa/v4#/">
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/saudi_sports.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">الألعاب السعودية</h5>
                                </div>
                            </div>
                        </a>

                    </div>

                </div>

                <div class="col-6 col-lg-3 mt-3">

                    <div class="col_three_content w-100 h-100">

                        <a href="https://firstsaudi.net/home">
                            <div class="card p-3">
                                <div class="image_wrapper">
                                    <img class="card-img-top" src="@/assets/images/services/first.webp" alt="" />
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title text-center">بطولة فيرست</h5>
                                </div>
                            </div>
                        </a>

                    </div>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'Sports',
}
</script>

<style lang="scss" scoped>
#sports_content {

    min-height: 100vh;

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        #first_row {

            nav {
                .breadcrumb {

                    li:first-of-type {
                        font-size: 16px;
                        line-height: 180%;
                        background: $Linear-Blue;
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    li:nth-of-type(2n) {
                        font-family: 'FFShamelFamily-Bold';
                        font-size: 18px;
                        line-height: 180%;
                        color: $Green;
                    }

                }

                .breadcrumb-item::before {
                    float: right;
                    margin-left: 8px;
                    background: $Linear-Blue;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .col_one_content {

                p {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;
                }

                h5 {
                    font-family: 'FFShamelFamily-Bold';
                    font-size: 16px;
                    line-height: 156%;
                    color: $Green;
                }

                h5:nth-of-type(2n) {
                    color: $Yellow;
                }

                ul {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    padding-right: 15px;
                    padding-left: 0px;
                    text-align: justify;

                    li::marker {
                        color: $Yellow;
                    }
                }

            }

            // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
            .col_two_content {

                position: relative;

                width: 636px;
                height: 426px;

                @include breakpoints(x-small) {
                    width: 351px;
                    height: 235px;
                }

                @include breakpoints(small) {
                    width: 516px;
                    height: 345px;
                }

                @include breakpoints(medium) {
                    width: 696px;
                    height: 466px;
                }

                @include breakpoints(large) {
                    width: 456px;
                    height: 305px;
                }

                @include breakpoints(x-Large) {
                    width: 546px;
                    height: 366px;
                }

                background: $Green;
                box-sizing: border-box;

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                .img_wrapper {

                    position: absolute;
                    top: 1px;
                    left: 1px;

                    width: 634px;
                    height: 424px;

                    @include breakpoints(x-small) {
                        width: 349px;
                        height: 233px;
                    }

                    @include breakpoints(small) {
                        width: 514px;
                        height: 343px;
                    }

                    @include breakpoints(medium) {
                        width: 694px;
                        height: 464px;
                    }

                    @include breakpoints(large) {
                        width: 454px;
                        height: 303px;
                    }

                    @include breakpoints(x-Large) {
                        width: 544px;
                        height: 364px;
                    }

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                    // border: solid 2px $Green;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                    }

                    img:hover {
                        opacity: 1;
                        -webkit-transition: opacity 0.5s linear 0.2s;
                        -moz-transition: opacity 0.5s linear 0.2s;
                        transition: opacity 0.5s linear 0.2s;
                    }

                }

            }

        }

        #second_row {

            h5 {

                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Yellow;
            }

            .col_three_content {

                .card {

                    background: $Dark-Green;

                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

                    height: 200px;

                    @include breakpoints(x-small) {
                        height: 225px;
                    }

                    .image_wrapper {
                        width: 60%;
                        height: 80px;
                        margin: auto;

                        @include breakpoints(x-small) {
                            width: 80%;
                        }

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }

                    .card-body {

                        h5 {
                            font-family: 'FFShamelFamily-Bold';
                            font-size: 16px;
                            line-height: 156%;
                            color: $White;
                        }

                    }


                }

                .card:hover {
                    background: $Linear-Blue;
                }

            }

        }

    }

}
</style>